<script setup lang="ts">
import { useUIStore } from '@/stores/ui'

const uiStore = useUIStore()

const typeStyles: Record<string, { bg: string; border: string; icon: string }> = {
  success: { bg: 'var(--colors-success-light, #dcfce7)', border: 'var(--colors-success, #22c55e)', icon: '\u2713' },
  error:   { bg: 'var(--colors-error-light, #fef2f2)', border: 'var(--colors-error, #ef4444)', icon: '\u2717' },
  warning: { bg: 'var(--colors-warning-light, #fffbeb)', border: 'var(--colors-warning, #f59e0b)', icon: '\u26A0' },
  info:    { bg: 'var(--colors-primary-light, #eff6ff)', border: 'var(--colors-primary, #3b82f6)', icon: '\u2139' },
}
</script>

<template>
  <Teleport to="body">
    <div class="toast-container" aria-live="polite">
      <TransitionGroup name="toast">
        <div
          v-for="n in uiStore.notifications"
          :key="n.id"
          class="toast"
          :style="{
            backgroundColor: typeStyles[n.type]?.bg,
            borderLeftColor: typeStyles[n.type]?.border,
          }"
        >
          <span class="toast__icon">{{ typeStyles[n.type]?.icon }}</span>
          <div class="toast__body">
            <div class="toast__title">{{ n.title }}</div>
            <div v-if="n.message" class="toast__message">{{ n.message }}</div>
          </div>
          <button class="toast__close" @click="uiStore.removeNotification(n.id)">&times;</button>
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<style scoped>
.toast-container {
  position: fixed;
  top: var(--spacing-md);
  right: var(--spacing-md);
  z-index: var(--z-index-tooltip);
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 400px;
}

.toast {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: var(--spacing-sm) var(--spacing-md);
  border-radius: var(--radius-md, 8px);
  border-left: 4px solid;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  background: white;
}

.toast__icon {
  flex-shrink: 0;
  font-size: 1rem;
  line-height: 1.4;
}

.toast__body {
  flex: 1;
  min-width: 0;
}

.toast__title {
  font-weight: 600;
  font-size: 0.875rem;
}

.toast__message {
  font-size: 0.8rem;
  color: var(--colors-text-secondary, #666);
  margin-top: 2px;
}

.toast__close {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1.1rem;
  color: var(--colors-text-secondary, #999);
  padding: 0 4px;
  line-height: 1;
}

.toast-enter-active {
  transition: all 0.3s ease;
}
.toast-leave-active {
  transition: all 0.2s ease;
}
.toast-enter-from {
  opacity: 0;
  transform: translateX(100%);
}
.toast-leave-to {
  opacity: 0;
  transform: translateX(100%);
}
</style>
